export const personal = [
  {
    label: "Id",
    name: "idpersonal",
    type: "INTEGER",
    readonly: true,
  },
  {
    label: "Nombre",
    name: "nombre",
    type: "STRING",
    showOnList: true,
    showAsLabel: true,
  },
  {
    label: "Oficina",
    name: "idoficina",
    type: "oficina",
    showOnList: true,
    allowNull: true,
  },
  {
    label: "Cargo",
    name: "idcargo",
    type: "cargo",
    showOnList: true,
    allowNull: true,
  },
  {
    label: "Fecha inicio",
    name: "fecha_ini",
    type: "DATE",
    showOnList: true,
  },
  {
    label: "Fecha fin",
    name: "fecha_fin",
    type: "DATE",
    allowNull: true,
    showOnList: true,
  },
  {
    label: "Usuario",
    name: "idusuario",
    type: "usuario",
    unique: true,
  },
  {
    label: "Empresa",
    name: "idempresa",
    type: "empresa",
    allowNull: true,
    showOnList: true,
  },
  {
    label: "Activo",
    name: "activo",
    type: "BOOLEAN",
    allowNull: true,
    showOnList: true,
    readonly: true,
    doNotFilter: true,
    doNotSort: true,
  },
];
